<template>
    <main-content-marketing>
        <page-title icon="dashboard" title_text="درگاه های اینترنتی">
            <router-link class="btn btn-success shadow-sm mx-2 px-4 py-2" style="border-radius: 20px; border-color: #bbb;"
                         to="/marketing/tools">
                <span class="pr-2">ابزارهای همکاری در فروش</span>
            </router-link>
        </page-title>
        <div class="row mt-4">
            <div class="col-12 col-md my-2">
                <dashboard-box
                        :has_rail="true"
                        :number="status == 'success' ? marketing.marketer_profit_amount : 0"
                        color="#FF8D8D"
                        title="سود همکاری در فروش"
                >
                    <svg
                            fill="#fff"
                            height="24px"
                            viewBox="0 0 24 24"
                            width="24px"
                            xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M0 0h24v24H0z" fill="none"/>
                        <path
                                d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
                        />
                    </svg>
                </dashboard-box>
            </div>
            <div class="col-12 col-md my-2">
                <dashboard-box
                        :number="status == 'success' ? marketing.subsets_number : 0"
                        color="#00bea5"
                        title="تعداد زیرمجموعه ها"
                >

                    <svg fill="#fff" height="24px" viewBox="0 0 24 24" width="24px" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 0h24v24H0V0z" fill="none"/>
                        <path
                                d="M9 13.75c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5zM4.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25H4.34zM9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm7.04 6.81c1.16.84 1.96 1.96 1.96 3.44V19h4v-1.75c0-2.02-3.5-3.17-5.96-3.44zM15 12c1.93 0 3.5-1.57 3.5-3.5S16.93 5 15 5c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35z"/>
                    </svg>
                </dashboard-box>
            </div>
            <div class="col-12 col-md my-2">
                <dashboard-box
                        :number="status == 'success' ? marketing.clicks_number : 0"
                        color="#FF8D8D"
                        title="تعداد کل کلیک ها"
                >

                    <svg enable-background="new 0 0 24 24" fill="#fff" height="24px"
                         viewBox="0 0 24 24"
                         width="24px" xmlns="http://www.w3.org/2000/svg">
                        <rect fill="none" height="24" width="24"/>
                        <path
                                d="M11.71,17.99C8.53,17.84,6,15.22,6,12c0-3.31,2.69-6,6-6c3.22,0,5.84,2.53,5.99,5.71l-2.1-0.63C15.48,9.31,13.89,8,12,8 c-2.21,0-4,1.79-4,4c0,1.89,1.31,3.48,3.08,3.89L11.71,17.99z M22,12c0,0.3-0.01,0.6-0.04,0.9l-1.97-0.59C20,12.21,20,12.1,20,12 c0-4.42-3.58-8-8-8s-8,3.58-8,8s3.58,8,8,8c0.1,0,0.21,0,0.31-0.01l0.59,1.97C12.6,21.99,12.3,22,12,22C6.48,22,2,17.52,2,12 C2,6.48,6.48,2,12,2S22,6.48,22,12z M18.23,16.26L22,15l-10-3l3,10l1.26-3.77l4.27,4.27l1.98-1.98L18.23,16.26z"/>
                    </svg>
                </dashboard-box>
            </div>
            <div class="col-12 col-md my-2">
                <dashboard-box :has_rail="true"
                               :number="status == 'success' ? marketing.marketer_balance : 0"
                               color="#00bea5"
                               title="موجودی قابل تسویه"
                >

                    <svg enable-background="new 0 0 24 24" fill="#fff" height="24px"
                         viewBox="0 0 24 24"
                         width="24px" xmlns="http://www.w3.org/2000/svg">
                        <g>
                            <rect fill="none" height="24" width="24"/>
                            <path
                                    d="M19,14V6c0-1.1-0.9-2-2-2H3C1.9,4,1,4.9,1,6v8c0,1.1,0.9,2,2,2h14C18.1,16,19,15.1,19,14z M17,14H3V6h14V14z M10,7 c-1.66,0-3,1.34-3,3s1.34,3,3,3s3-1.34,3-3S11.66,7,10,7z M23,7v11c0,1.1-0.9,2-2,2H4c0-1,0-0.9,0-2h17V7C22.1,7,22,7,23,7z"/>
                        </g>
                    </svg>
                </dashboard-box>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-12 col-lg-5 my-3">
                <recent-marketing></recent-marketing>
            </div>
            <div
                    class="d-none d-lg-block col-lg-7 my-3"
            >
                <chart-empty :status="'success'"></chart-empty>
            </div>
        </div>
        <p class="font-weight-bold">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#F19E39"><path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
            <span>
              آمار نشان داده شده تا روز قبل محاسبه شده است.
              </span>
        </p>
    </main-content-marketing>
</template>

<script>
    import DashboardBox from "@/pages/dashboard/dashboard-box";
    import PageTitle from "@/components/main/components/pageTitle";
    import {ApiService} from "@/common/api.service";
    import ChartEmpty from "@/pages/dashboard/chart_empty";
    import RecentMarketing from "@/pages/marketing/recent-marketing";
    import MainContentMarketing from "@/components/main-content-marketing";

    export default {
        name: "marketing-dashboard",
        components: {MainContentMarketing, RecentMarketing, PageTitle, DashboardBox, ChartEmpty},
        data() {
            return {
                marketing: null,
                status: 'loading',
            }
        },
        async mounted() {

            let res = await ApiService.get('marketing', '')
            this.status = 'success'
            this.marketing = res.data.data
        }
    }
</script>

<style scoped>

</style>